angular.module('ui2.0Directives')
    .directive('slRawData', ['$rootScope','$http','$timeout','$routeParams','$window' ,'listService','$uibModal', function ($rootScope,$http,$timeout,$routeParams,$window ,listService,$modal) {
       return {
           restrict: 'AE',
           templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/slRawData.html"),
           link: function ($scope, element, attrs) {
               $scope.browse = false;
               $scope.xl = false;
               $scope.zip = true;
               $scope.count = 0;
               $scope.intl_msg = intl_msg;
               $scope.fileList = [];
               $scope.checkedId = [];
               $scope.radioButtonValue ='zip';
               $scope.multipleFileUpload = false;
               $scope.singleFileUpload = true;
               $scope.error = false;
               var notificationMsg1;
               var notificationMsg2;
               $scope.errorMsg = '';
               $scope.selectedOption = 'zip';
               $scope.actionUrl = '/slRawData/uploadBulk';
               $scope.chooseUploadOption = (eve) => {
                   if (eve && eve.defaultValue == 'xl') {
                       if (checkedVal.length <= 0) {
                           $scope.browse = false;
                           $scope.radioValueChanged();
                           Toaster.create(intl_msg[6443],{iconClass:"icon-Information_filled"});
                           $scope.cancelPopUp();
                       } else {
                           $scope.multipleFileUpload = true;
                           $scope.singleFileUpload = false;
                           $scope.xl = true;
                           $scope.zip = false;
                           $scope.browse = true;
                           $scope.radioValueChanged();
                           $scope.checkedId = checkedVal;
                           $scope.selectedOption= eve.defaultValue;
                           $scope.actionUrl = '/slRawData/v1/singleFormatBulkUpload';
                       }
                   }
                   if (eve && eve.defaultValue == 'zip') {
                       $scope.browse = true;
                       $scope.multipleFileUpload = false;
                       $scope.singleFileUpload = true;
                       $scope.xl = false;
                       $scope.zip = true;
                       $scope.selectedOption= eve.defaultValue;
                       $scope.actionUrl = '/slRawData/uploadBulk';
                       $scope.radioValueChanged();
                   }
               };
               $scope.onSubmitForm = (eve) => {
                   if($scope.fileList.length > 0){
                       if ($scope.xl) {
                           var fd = new FormData();
                           var cslIds =[];
                           $scope.checkedId.filter((eachId,index)=>{
                               // fd.append('cslIds[' + index + ']', eachId);
                               cslIds.push(eachId);
                           });
                           fd.append('cslIds', cslIds)
                           $scope.fileList.map((files, index) => {
                               fd.append('rawDataFiles[' + index + ']', files);
                           });
                       }
                       if ($scope.zip) {
                           var fd = new FormData();
                           fd.append('multipartFile', $scope.fileList[0]);
                           fd.append('entityTypeId', listJson.entityTypeId);
                       }
                       startLoader();
                       $http.post($scope.actionUrl, fd, {
                           transformRequest: angular.identity,
                           headers: {"Content-Type": undefined}
                       }).then((d) => {
                           if (d.data.includes('200')) {
                               $scope.cancelPopUp();
                               notificationMsg1 = intl_msg[25813];
                               notificationMsg2 = intl_msg[25540];
                               stopLoader();
                               $scope.notificationPopUp();
                               var bulkType = $(".modal-title:visible").text();
                               bulkType ? SirionUtils.triggerHeap(3, "bulk", null, bulkType, $scope) : '';
                           }
                           else{
                               $scope.cancelPopUp();
                               notificationMsg1 = d.data;
                               notificationMsg2 = '';
                               stopLoader();
                               $scope.notificationPopUp();
                           }
                       });

                   }else{
                       $scope.error = true;
                       $scope.errorMsg ='No File Selected';
                   }
               }
               $scope.checkFileUpload = (event ,dragDropFiles) => {
                   var temp =[]
                   if(typeof event == "undefined" || event == null){
                       temp= dragDropFiles;
                   }else{
                       temp = Object.keys(event.files).map(e => event.files[e]);
                   }
                   if ($scope.xl) {
                       var current = $scope.fileList && $scope.fileList.length;
                       var uploaded = temp.length;
                       var maxFileUploadCount = listService.checkCount(temp,$scope.fileList);
                       if (maxFileUploadCount) {
                           var totalSum =listService.getAllFileSizeSum($scope.fileList);
                           var fileSizeCheck = listService.checkFileSize(temp,totalSum);
                           if (fileSizeCheck) {
                               var validExtension = listService.checkFileExtension(temp, $scope.selectedOption);
                               if (validExtension) {
                                  var duplicateCheck = listService.checkDuplicateFileUpload(temp,$scope.fileList);
                                   if($scope.fileList.length > 0){
                                       $scope.fileList = $scope.fileList.concat(duplicateCheck['fileArray']);
                                   }else{
                                       $scope.fileList = duplicateCheck['fileArray'];
                                   }
                                    $scope.error = duplicateCheck.duplicateFiles;
                                    $scope.errorMsg = intl_msg[29497]?intl_msg[29497]:'Duplicate files cannot be uploaded';

                               } else {
                                   $scope.error = true;
                                   $scope.errorMsg = intl_msg[6431];
                               }
                           } else {
                               $scope.error = true;
                               $scope.errorMsg = intl_msg[29573]?intl_msg[29573]:'Please upload a file less than 75 MB in size';
                           }
                       } else {
                           $scope.error = true;
                           $scope.errorMsg = intl_msg[29572]?intl_msg[29572]:'Maximum four files can be uploaded';
                       }
                   }
                   if ($scope.zip) {
                       var totalFiles = temp.concat($scope.fileList);
                       if(totalFiles.length > 1){
                           $scope.error = true;
                           $scope.errorMsg = intl_msg[29571]?intl_msg[29571]: 'More than one file cannot be uploaded';
                       }else{
                           var totalSum =listService.getAllFileSizeSum($scope.fileList);
                           var fileSizeCheck= listService.checkFileSize(temp,totalSum);
                          if(fileSizeCheck){
                              var validExtension = listService.checkFileExtension(temp , $scope.selectedOption)
                              if(validExtension){
                                  $scope.fileList = temp;
                                  $scope.error = false;
                              }else{
                                  $scope.errorMsg = intl_msg[6431];
                                  $scope.error = true;
                              }

                          }else{
                              $scope.errorMsg = intl_msg[29573]?intl_msg[29573]:'Please upload a file less than 75 MB in size';
                              $scope.error =true;
                          }

                       }
                   }
                   if (!$scope.$$phase) {
                       $scope.$apply();
                   }
               }
               $scope.radioValueChanged =()=>{
                   $scope.fileList=[];
                   $scope.error =false;
                   $scope.errorMsg ='';
               };
               $scope.cancelPopUp = ()=> {
                $scope.fileList =[];
                $scope.error =false;
                $scope.errorMsg ='';
                $scope.zip=false;
                $scope.xl=false;
                $scope.browse =false;
                listService.projectPopupInstance.close();
                checkedVal = [];
                $scope.checkedId = [];
                listService.projectPopupInstance= null;
               };
               $scope.removeFile = (eve) =>{
                  if(eve && eve.target){
                     var fileName = eve.target.getAttribute('name');
                     var temp = $scope.fileList;
                   $scope.fileList.filter((file ,index)=>{
                       if(fileName == file.name){
                           temp.splice(index,1);
                       }
                   });
                  }
                  $scope.fileList = temp;
                  $scope.error =false;
                  $scope.errorMsg  ='';
               };
               $scope.notificationPopUp = () =>{
                   checkedVal = [];
                   $scope.checkedId = [];
                   /*$("#bulkCreateServiceDialogSuccess").dialog("open");
                   $("#bulkCreateServiceDialogSuccess").dialog( "option", "title", intl_msg[24153] );
                   $("#bulkCreateServiceDialogSuccess").html('<div class="fileSuccess"><label>'+notificationMsg1
                       +'</label><div class="fileSuccessNotify"><div><label>'
                       +notificationMsg2+'</label></div><div class="modal-footer"><input type="submit" onclick = "$(\'#bulkCreateServiceDialogSuccess\').dialog(\'close\')" value="'+intl_msg[24184]+'" name="upload"></div>');
                   $("#bulkCreateServiceDialogSuccess").off("dialogclose");
                   $(".checkAll:visible").prop("indeterminate", false);
                   $(".checkAll:visible").prop("checked",false);
                   $("#bulkCreateServiceDialogSuccess").on("dialogclose",function () {
                       commonUtil.animateUserTaskIcon();

                       $("#bulkCreateServiceDialogSuccess").off("dialogclose");
                   });*/
                   Toaster.create(intl_msg[25813]+'<br>'+intl_msg[25540]);
                   $('#cr').dataTable().fnDraw();
               }
            }
     }

}]);

